import { useSliderStore } from '../stores/sliderStore';

// ponytail: SliderContext thin facade mapping to sliderStore.
export const useSlider = () => useSliderStore();

export const SliderProvider = ({ children }) => <>{children}</>;

export default useSliderStore;
